document.addEventListener("DOMContentLoaded", function () {
	document.body.addEventListener("click", function (event) {
	  const target = event.target;
	  console.log(target)
	  if (target.matches('[name="checkout"], [name="goto_pp"], [name="goto_gc"]')) {
		console.log("click ")
		const form = target.closest("form");
		if (form) {
		  const terms = form.querySelector('.cart__terms [type="checkbox"]');
		  if (terms) {
			if (terms.checked) {
			  form.submit();
			} else {
			  alert(terms.getAttribute("data-confirm"));
			  event.preventDefault();
			}
		  }
		}
	  }
	});
  
	
});
  